import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  classItem: {
    padding: '.5rem',
    border: `.0631rem solid ${t.gray03}`,
    marginBottom: '.6rem',
    backgroundColor: t.white,
    cursor: 'move',
    lineHeight: 1,
  },

  index: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '.65rem',
    width: '1.2rem',
    height: '1.2rem',
    borderRadius: '50%',
    backgroundColor: t.gray03,
    marginRight: '.4rem',
    verticalAlign: 'middle',
  },

  label: {
    verticalAlign: 'middle',
  },
}))

export default useStyles
